module.exports = __webpack_public_path__ + "static/lord-of-light-11c56b538e08a093a235927f15efd6ae.jpg";